import { Dispatch } from '../../../../../types/actions';
import { SnackbarVariant, ISnackbarControlModel } from '../../store/types';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SNACKBAR_ID_REINSTALL } from '../constants';
import { getMessages } from '../../../../../store/constants';
import { IGetState } from 'app/types/types';

export const snackbarErrorReinstall =
() => {
    return (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const text = getMessages().getText('error.button.reinstall.message');
        const link = getMessages().getText('error.button.reinstall.link');

        const buttons: ISnackbarControlModel[] = [
            {
                onClick: () => {
                    location.href = link;
                },
                text: getMessages().getText('error.button.reinstall')
            }
        ];
        dispatch(addUpdateSnackbarWithBubble({
            id: SNACKBAR_ID_REINSTALL,
            buttons,
            text,
            title: null,
            icon: 'drive',
            variant: SnackbarVariant.ERROR
        }));
    }
};
